module.exports = __webpack_public_path__ + "e4868a707fbe94c0d1365fe6d84c4e81.svg";